"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NowportsColombiaSas = void 0;
exports.NowportsColombiaSas = {
    id: 'nowportsColombiaSas',
    companyName: 'Nowports Colombia Sas',
    transportModes: ['sea', 'air'],
    freightGate: {
        isOnboarded: true,
        realm: 'nowportsColombiaSas',
    },
    isInternal: false,
    isActive: true,
    countries: ['CO'],
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTm93cG9ydHNDb2xvbWJpYVNhcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9hZ2VudHMvZGF0YS9Ob3dwb3J0c0NvbG9tYmlhU2FzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEsbUJBQW1CLEdBQVU7SUFDdEMsRUFBRSxFQUFFLHFCQUFxQjtJQUN6QixXQUFXLEVBQUUsdUJBQXVCO0lBQ3BDLGNBQWMsRUFBRSxDQUFDLEtBQUssRUFBRSxLQUFLLENBQUM7SUFDOUIsV0FBVyxFQUFFO1FBQ1QsV0FBVyxFQUFFLElBQUk7UUFDakIsS0FBSyxFQUFFLHFCQUFxQjtLQUMvQjtJQUNELFVBQVUsRUFBRSxLQUFLO0lBQ2pCLFFBQVEsRUFBRSxJQUFJO0lBQ2QsU0FBUyxFQUFFLENBQUMsSUFBSSxDQUFDO0NBQ3BCLENBQUEifQ==